
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta } from "/app/src/pages/index.vue?macro=true";
import { default as _91_46_46_46404_93t2skKwoN9dqEfMyc_dt_7Zhym3pH4S7JkjjPy4BGGswMeta } from "/app/src/pages/[...404].vue?macro=true";
import { default as _91id_93wSzkbmsTSisCZTR0p1ZZ1PTZZS8unqGpv8kWZs70TE0Meta } from "/app/src/pages/nfts/[id].vue?macro=true";
import { default as aek4fOV3BuiyN8B2csouPeDUi_cBFaoQeyeIP1d0DfAnMMeta } from "/app/src/pages/tokens/ae.vue?macro=true";
import { default as indexv4ls3xbZQw9Rz6e9CKfUysfypVLkCS34cuIVJiS_mzIMeta } from "/app/src/pages/nfts/index.vue?macro=true";
import { default as indexDn_z2eMq4gIwlqD3OUGb0Z5hfHYJjFLFy2_45Qo7xg0tYMeta } from "/app/src/pages/names/index.vue?macro=true";
import { default as indexTrl4k1ZpQifW2M2GRkEoIshKjIWHQBwd1aHMk5bt9eAMeta } from "/app/src/pages/nodes/index.vue?macro=true";
import { default as _91id_93w_45fG_45d5jzY66ediW_nX8CUgsNvNFAuu8dvyWc4W8kEQMeta } from "/app/src/pages/search/[id].vue?macro=true";
import { default as _91id_93QAZHu2xcsRcBzfHKN69zoiu7hjSR6Wet3Qvlxw_aIRkMeta } from "/app/src/pages/tokens/[id].vue?macro=true";
import { default as indexxIOxLSRGekV4UE6w5xDgllzsR_45xk3IIN8Zug5H_WZo8Meta } from "/app/src/pages/charts/index.vue?macro=true";
import { default as namesDithmN6Wl7uLdXzqo_kBwiiLpfEvrPkGNNfgHv9sEAgMeta } from "/app/src/pages/charts/names.vue?macro=true";
import { default as pricenWdxx4acwmEvhF82MK9dt0dw5Tuo3bCk0rHguD6rIT8Meta } from "/app/src/pages/charts/price.vue?macro=true";
import { default as indexovHq1CkM7brG57rYQB1msqUmEA9AbBiJaxfkZKkQLs0Meta } from "/app/src/pages/mining/index.vue?macro=true";
import { default as _91name_93P07ps_pFzfiASulEIxucgA8t1Se9D3QysLiQRk2z_45o8Meta } from "/app/src/pages/names/[name].vue?macro=true";
import { default as _91id_93SUEmA9jcrCsfuMmJshuuF1YUJrq_5CyneEI8I2k7v50Meta } from "/app/src/pages/oracles/[id].vue?macro=true";
import { default as indextmo0XzdcDyqW1OibygIw7K9attzNS0xZ1sC9rvjmqA8Meta } from "/app/src/pages/tokens/index.vue?macro=true";
import { default as indexDG3kr8_45ut6N3DPcQqrpi7fSVbyznJ0_tza_grOneB2AMeta } from "/app/src/pages/wallet/index.vue?macro=true";
import { default as _91id_93qAYPo_AKQML0_45rl_1tiPogAI5hR9k_45kabVh8VmrTJtIMeta } from "/app/src/pages/accounts/[id].vue?macro=true";
import { default as indexOpYGE36VQkesArJ7bTXySAMTiVgbXtXevuUUwRPOgigMeta } from "/app/src/pages/oracles/index.vue?macro=true";
import { default as indexJMyHX7LL18dFxXjnwORWgw_45FBvtFcTTvwZa0rCpurlQMeta } from "/app/src/pages/accounts/index.vue?macro=true";
import { default as _91id_93VZ_45Z_45CO3xt1rZS6UToK9dHFFoSAZsUOkgoCBzseq0l8Meta } from "/app/src/pages/contracts/[id].vue?macro=true";
import { default as _91id_93nbx5qR4p_45G5xqYsgV17xTPgKPzBlQftSa2AnsqDL3UkMeta } from "/app/src/pages/keyblocks/[id].vue?macro=true";
import { default as accountsxb_TiPLv8xlGbgZbDerFxxxi7jO8cxPoKWW4kXiKpGoMeta } from "/app/src/pages/charts/accounts.vue?macro=true";
import { default as hashrate59dLT50aXWwr6KcPNHk9_0rajHfWbnA4hfdueCKb8EQMeta } from "/app/src/pages/charts/hashrate.vue?macro=true";
import { default as indexlL39y3UD6kU1ig8Nmse1m08EE7_45X7B4abGxcIxBkx6EMeta } from "/app/src/pages/contracts/index.vue?macro=true";
import { default as indexQKffOgTo9DSqJEuOEyt_uFsROi0Tvn_45eRzgoCsNCmZ0Meta } from "/app/src/pages/keyblocks/index.vue?macro=true";
import { default as contractsSm9MmahX0il4wa9vBKYFDRAyqfKZLoa3YzmBYWD9_45REMeta } from "/app/src/pages/charts/contracts.vue?macro=true";
import { default as keyblocksebfojnzjZ_3OvQZ3rNclTjh3f5z3oHV84Ke2MzuSQY0Meta } from "/app/src/pages/charts/keyblocks.vue?macro=true";
import { default as indexXgSK9m8U8NXZ3Wjk7j_LtOMQZ2bd3gbVagyDCy0HySkMeta } from "/app/src/pages/dex-trades/index.vue?macro=true";
import { default as _91id_939EGKMMYgpPKooUkh973B0mLOanIyzIGbKwLFQWFwEiQMeta } from "/app/src/pages/microblocks/[id].vue?macro=true";
import { default as difficultyhDoQ4CVS4cQYz6N_PnhwQEn7nDMiuDag6UgWCjMgsfQMeta } from "/app/src/pages/charts/difficulty.vue?macro=true";
import { default as _91id_93lBJ008Xin1LJkIjzRIcI89RhIxhOQao_dVTCTQR68gsMeta } from "/app/src/pages/transactions/[id].vue?macro=true";
import { default as indexMt3pB0MebbSWVbEAuwiPvl81LiFtm9WD0uYGBaPm9ZMMeta } from "/app/src/pages/transactions/index.vue?macro=true";
import { default as transactionsfUmvqDeNfPgonB4K_XmP_Smt5R95MzYd0sBk3oRuimUMeta } from "/app/src/pages/charts/transactions.vue?macro=true";
import { default as _91id_93yAsTiWs3lD46o8HHqQKy9Gg0VOCNTJMW4fhdvwWK_FsMeta } from "/app/src/pages/state-channels/[id].vue?macro=true";
import { default as indexQNpaewHSh3fzuS5R_4dZkVZf6igv4CU3JQOJSSCUkOMMeta } from "/app/src/pages/privacy-policy/index.vue?macro=true";
import { default as indexjU2lXR7I5Sr4TyhV6U07vCJsbRD6Iyv6xoOz1_RsVeIMeta } from "/app/src/pages/state-channels/index.vue?macro=true";
import { default as index6dNr4aNooUsTzK_Cx2NDlr_45xtnmHja5xWG7xj1TtCjUMeta } from "/app/src/pages/terms-of-service/index.vue?macro=true";
import { default as indexa_dgb6btXqTqAfwVeto95d2XohYj5q7uBBbnywiLGskMeta } from "/app/src/pages/contract-verification/index.vue?macro=true";
import { default as resultKrRvydVXK78hIdJ0hrwSXCIgsIG86lH_45kK4_6EwEwtQMeta } from "/app/src/pages/contract-verification/result.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta || {},
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "404",
    path: "/:404(.*)*",
    component: () => import("/app/src/pages/[...404].vue")
  },
  {
    name: "nfts-id",
    path: "/nfts/:id()",
    component: () => import("/app/src/pages/nfts/[id].vue")
  },
  {
    name: "tokens-ae",
    path: "/tokens/ae",
    component: () => import("/app/src/pages/tokens/ae.vue")
  },
  {
    name: "nfts",
    path: "/nfts",
    component: () => import("/app/src/pages/nfts/index.vue")
  },
  {
    name: "names",
    path: "/names",
    component: () => import("/app/src/pages/names/index.vue")
  },
  {
    name: "nodes",
    path: "/nodes",
    component: () => import("/app/src/pages/nodes/index.vue")
  },
  {
    name: "search-id",
    path: "/search/:id()",
    component: () => import("/app/src/pages/search/[id].vue")
  },
  {
    name: "tokens-id",
    path: "/tokens/:id()",
    component: () => import("/app/src/pages/tokens/[id].vue")
  },
  {
    name: "charts",
    path: "/charts",
    component: () => import("/app/src/pages/charts/index.vue")
  },
  {
    name: "charts-names",
    path: "/charts/names",
    component: () => import("/app/src/pages/charts/names.vue")
  },
  {
    name: "charts-price",
    path: "/charts/price",
    component: () => import("/app/src/pages/charts/price.vue")
  },
  {
    name: "mining",
    path: "/mining",
    component: () => import("/app/src/pages/mining/index.vue")
  },
  {
    name: "names-name",
    path: "/names/:name()",
    component: () => import("/app/src/pages/names/[name].vue")
  },
  {
    name: "oracles-id",
    path: "/oracles/:id()",
    component: () => import("/app/src/pages/oracles/[id].vue")
  },
  {
    name: "tokens",
    path: "/tokens",
    component: () => import("/app/src/pages/tokens/index.vue")
  },
  {
    name: "wallet",
    path: "/wallet",
    component: () => import("/app/src/pages/wallet/index.vue")
  },
  {
    name: "accounts-id",
    path: "/accounts/:id()",
    component: () => import("/app/src/pages/accounts/[id].vue")
  },
  {
    name: "oracles",
    path: "/oracles",
    component: () => import("/app/src/pages/oracles/index.vue")
  },
  {
    name: "accounts",
    path: "/accounts",
    component: () => import("/app/src/pages/accounts/index.vue")
  },
  {
    name: "contracts-id",
    path: "/contracts/:id()",
    component: () => import("/app/src/pages/contracts/[id].vue")
  },
  {
    name: "keyblocks-id",
    path: "/keyblocks/:id()",
    component: () => import("/app/src/pages/keyblocks/[id].vue")
  },
  {
    name: "charts-accounts",
    path: "/charts/accounts",
    component: () => import("/app/src/pages/charts/accounts.vue")
  },
  {
    name: "charts-hashrate",
    path: "/charts/hashrate",
    component: () => import("/app/src/pages/charts/hashrate.vue")
  },
  {
    name: "contracts",
    path: "/contracts",
    component: () => import("/app/src/pages/contracts/index.vue")
  },
  {
    name: "keyblocks",
    path: "/keyblocks",
    component: () => import("/app/src/pages/keyblocks/index.vue")
  },
  {
    name: "charts-contracts",
    path: "/charts/contracts",
    component: () => import("/app/src/pages/charts/contracts.vue")
  },
  {
    name: "charts-keyblocks",
    path: "/charts/keyblocks",
    component: () => import("/app/src/pages/charts/keyblocks.vue")
  },
  {
    name: "dex-trades",
    path: "/dex-trades",
    component: () => import("/app/src/pages/dex-trades/index.vue")
  },
  {
    name: "microblocks-id",
    path: "/microblocks/:id()",
    component: () => import("/app/src/pages/microblocks/[id].vue")
  },
  {
    name: "charts-difficulty",
    path: "/charts/difficulty",
    component: () => import("/app/src/pages/charts/difficulty.vue")
  },
  {
    name: "transactions-id",
    path: "/transactions/:id()",
    component: () => import("/app/src/pages/transactions/[id].vue")
  },
  {
    name: "transactions",
    path: "/transactions",
    component: () => import("/app/src/pages/transactions/index.vue")
  },
  {
    name: "charts-transactions",
    path: "/charts/transactions",
    component: () => import("/app/src/pages/charts/transactions.vue")
  },
  {
    name: "state-channels-id",
    path: "/state-channels/:id()",
    component: () => import("/app/src/pages/state-channels/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/app/src/pages/privacy-policy/index.vue")
  },
  {
    name: "state-channels",
    path: "/state-channels",
    component: () => import("/app/src/pages/state-channels/index.vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    component: () => import("/app/src/pages/terms-of-service/index.vue")
  },
  {
    name: "contract-verification",
    path: "/contract-verification",
    component: () => import("/app/src/pages/contract-verification/index.vue")
  },
  {
    name: "contract-verification-result",
    path: "/contract-verification/result",
    component: () => import("/app/src/pages/contract-verification/result.vue")
  }
]